import { ContentType } from '../../../../../types';
import { TinyMCE } from '../types';
import { replaceTokensWithHandlebars } from './replaceTokensWithHandlebars';

export const getContentFromEditor = (editor: TinyMCE | null, contentType: ContentType) => {
  const shouldOutputPlaintext = contentType === ContentType.plaintext;
  const isEditorAvailable = editor && editor.initialized;
  return isEditorAvailable
    ? replaceTokensWithHandlebars(
        editor.getContent({ format: shouldOutputPlaintext ? 'text' : 'raw' }),
      )
    : '';
};
